window.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth > 576) { // Check if screen size is greater than 576px
        var maxHeight = 0;
        var elements = document.querySelectorAll('#SecondEvents .event-content-text');

        elements.forEach(function(element) {
            var thisHeight = element.offsetHeight;
            if (thisHeight > maxHeight) {
                maxHeight = thisHeight;
            }
        });

        elements.forEach(function(element) {
            element.style.height = maxHeight + 'px';
        });
    }
});